export const videos: { url: string; poster: string }[] = [
	{
		url: 'https://public.credit.club/site/videos/savings-founder-skyeng.mp4',
		poster: '/images/video-posters/invest-skyeng.jpg',
	},
	{
		url: 'https://public.credit.club/site/videos/savings-kira-300000-roubles.mp4',
		poster: '/images/video-posters/big-percent.jpg',
	},
	{
		url: 'https://public.credit.club/site/videos/savings-interview.mp4',
		poster: '/images/video-posters/invest-without-ndfl.jpg',
	},
	{
		url: 'https://public.credit.club/site/videos/savings-flat.mp4',
		poster: '/images/video-posters/portfel-review.jpg',
	},
]
